<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <div style="display: flex; justify-content: space-between; align-items:center; margin-top: 20px; margin-bottom: 10px;">
                <h1>ProManual</h1>
                <button *ngIf="!isLoggedIn" type="button" class="btn btn-primary" (click)="showLogin()" tabindex="2">Admin Login</button>
            </div>

            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <i class="fa fa-home "></i>
                    <span>ProManual </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container heightcls">
    <div *ngIf="isLoggedIn" class="component-content heightcls">
        <div class="jumbotron" style="overflow-y:scroll; height: 100%; margin:0">
            <h1>ProManual Administration</h1>
            <p>Welcome to the ProManual Administration application!</p>
            <br />
            <br />
            <!--<p>Download ProManual for UWP</p>
            <a href="api/Manuals/AppDownload" download>
                Click Here To Download
            </a>-->
            <h3>Download ProManual</h3>
            <ol>
                <li>
                    <a *ngIf="isProduction" href={{appInstallerLocation}} download>
                        Click Here To Download ProManual Installer
                    </a>
                    <a *ngIf="isDevelopment" href="{{appInstallerLocation}}" download>
                        Click Here To Download ProManual Installer (dev)
                    </a>
                    <a *ngIf="isStaging" href="{{appInstallerLocation}}" download>
                        Click Here To Download ProManual Installer (Training)
                    </a>
                </li>
                <li>
                    Navigate to your Download Folder and double click on <strong>ProManualInstaller.appinstaller</strong> to install ProManual.
                </li>
            </ol>
        </div>
    </div>
    <div *ngIf="!isLoggedIn" class="component-content heightcls">
        <div class="jumbotron" style="overflow-y:scroll; height: 100%; margin:0">
            <h3>Download ProManual</h3>
            <ol>
                <li>
                    <a *ngIf="isProduction" href={{appInstallerLocation}} download>
                        Click Here To Download ProManual Installer
                    </a>
                    <a *ngIf="isDevelopment" href="{{appInstallerLocation}}" download>
                        Click Here To Download ProManual Installer (dev)
                    </a>
                    <a *ngIf="isStaging" href="{{appInstallerLocation}}" download>
                        Click Here To Download ProManual Installer (Training)
                    </a>
                </li>
                <li>
                    Navigate to your Download Folder and double click on <strong>ProManualInstaller.appinstaller</strong> to install ProManual.
                </li>
            </ol>

            <!--<li class="navbar-brand" style="padding-right: 4px; font-size: 12px;">UWP Version: {{ uwpVersion }}</li>-->
        </div>
    </div>
</div>
<!--<login [showLoginModal]="showLoginModal"></login>-->
<login *ngIf="showLoginModal" (clickCancelLogin)="showLoginModal=false"></login>
